module.exports = __webpack_public_path__ + "static/frontUserNew/img/wxGZH-1.eb1fbab8.png";